import { render, staticRenderFns } from "./testhomeads.vue?vue&type=template&id=6bc83e04&scoped=true"
import script from "./testhomeads.vue?vue&type=script&lang=js"
export * from "./testhomeads.vue?vue&type=script&lang=js"
import style0 from "./testhomeads.vue?vue&type=style&index=0&id=6bc83e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc83e04",
  null
  
)

export default component.exports